{
  "name": "jst",
  "version": "2.5.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.conf.json --host=localhost",
    "build": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.2.4",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/google-maps": "22.2.4",
    "@angular/material": "22.2.4",
    "@angular/platform-browser": "22.2.3",
    "@angular/router": "22.2.3",
    "@angular/service-worker": "22.2.3",
    "@googlemaps/markerclusterer": "2.6.2",
    "@microsoft/signalr": "10.0.11",
    "@paypal/paypal-js": "^10.1.0",
    "@stripe/stripe-js": "10.1.0",
    "ngx-countdown": "22.0.0",
    "ngx-extended-pdf-viewer": "31.0.1",
    "ngx-progressbar": "14.0.0",
    "ngx-quill": "31.0.1",
    "rxjs": "7.8.2",
    "swiper": "14.3.0",
    "tslib": "2.8.1",
    "uuid": "14.0.3",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular/build": "22.2.4",
    "@angular/cli": "22.2.4",
    "@angular/compiler-cli": "22.2.3",
    "@angular/language-service": "22.2.3",
    "@eslint/js": "^10.0.1",
    "@types/google.maps": "3.66.7",
    "@types/node": "^26.6.5",
    "@types/stripe-v3": "^3.1.33",
    "angular-eslint": "^22.6.0",
    "eslint": "10.13.0",
    "jsdom": "30.1.3",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.72.0",
    "vitest": "5.0.5"
  },
  "overrides": {}
}
